import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useConditions} from './query';

const selectPreview = state => state.preview;
export function usePreview() {
    return useSelector(selectPreview);
}

export function useTotalPreview() {
    const preview = usePreview();
    return useMemo(() => preview.total, [preview]);
}

export function useFilterPreview(conditionIndex) {
    const {perFilter} = usePreview();
    return useMemo(() => (conditionIndex < perFilter.length ? perFilter[conditionIndex] ?? 0 : null), [conditionIndex, perFilter]);
}

export function useLastFilterPreview() {
    const conditions = useConditions();
    return useFilterPreview(conditions.length - 1);
}
